<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    {{ "MasterData.NewCatalogCategoryModal.Title" | i18nextEager }}
  </ng-template>
  <ng-template #content>
    <form [formGroup]="form">
      <div class="flex gap-lg w-full">
        <doka-text-field
          [frontDecoText]="i18n.selectedLanguage.toUpperCase()"
          class="flex-1"
          formControlName="name"
          data-testid="create-catalog-category-name-input"
          [label]="'MasterData.NewCatalogCategoryModal.Name' | i18nextEager"
          [placeholder]="'Common.Placeholder' | i18nextEager"
        />
        <doka-text-field
          class="w-14"
          formControlName="code"
          data-testid="create-catalog-category-code-input"
          [label]="'MasterData.NewCatalogCategoryModal.Code' | i18nextEager"
        />
      </div>
      @if (codeExists()) {
        <span class="text-sm text-text-error" data-testid="create-catalog-category-code-exists">
          {{ "MasterData.NewCatalogCategoryModal.CodeExists" | i18nextEager }}
        </span>
      }
    </form>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button
          [disabled]="isLoading()"
          (click)="closeModal()"
          color="secondary"
          data-testid="create-catalog-category-cancel-button"
          >{{ "Common.Cancel" | i18nextEager }}</doka-button
        >
        <doka-button
          type="submit"
          [disabled]="form.invalid || isLoading()"
          (click)="submit()"
          color="primary"
          data-testid="create-catalog-category-save-button"
          >{{ "Common.Save" | i18nextEager }}</doka-button
        >
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
